import './styles.scss';

import { ReactElement, Ref, forwardRef } from 'react';

import { FieldTypes } from '@/common/Field/types';
import { getClasses } from '@/utils';

const Field = forwardRef(
  ({ label, feedback, ...props }: FieldTypes.Props, ref: Ref<FieldTypes.RefType>): ReactElement => (
    <div {...props} className={getClasses('Field', 'Common', props.className)} data-label={label} data-feedback={feedback} ref={ref} />
  )
);
Field.displayName = 'Field';

export default Field;
